import { ScheduleTreatment, ScheduleTreatmentPeriod } from '../../../entities/ScheduleTreatment';

export default class ScheduleTreatmentModel {
  static listOfDays(treatments: ScheduleTreatment[]): Date[] {
    const dates = treatments.map(treatment => new Date(treatment.date));
    return Array.from(new Set(dates.map(date => date.toDateString())))
      .map(dateString => new Date(dateString))
      .sort((a, b) => a.getTime() - b.getTime());
  }
  static filterTreatmentsByDate(treatments: ScheduleTreatment[], date: Date): ScheduleTreatment | undefined {
    return treatments.find(treatment => {
      return new Date(treatment.date).toDateString() === new Date(date).toDateString();
    });
  }

  static orderByTratmentByDate(treatments: ScheduleTreatment | undefined): ScheduleTreatment | undefined {
    const orderPeriod = {
      [ScheduleTreatmentPeriod.MORNING]: 0,
      [ScheduleTreatmentPeriod.AFTERNOON]: 1,
      [ScheduleTreatmentPeriod.NIGHT]: 2
    };

    if (!treatments) return undefined;

    const orderedTreatments = Array.from(treatments.treatments).sort((a, b) => {
      const periodA = a.period || '';
      const periodB = b.period || '';
      return orderPeriod[periodA] - orderPeriod[periodB];
    });

    return {
      ...treatments,
      treatments: orderedTreatments
    };
  }
}
